import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { isNumber } from 'util';

@Pipe({
  name: 'absolute'
})
export class AbsoluteValuePipe implements PipeTransform {

  constructor() {
  }

  transform(value: any, args?: any): any {
    if (isNumber(value)) {
      return Math.abs(value);
    }

    return value;
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/shared/pipes/absolute-value.pipe.ts